import React from 'react';
import type { BadgeVariant } from '@/ui/theme/colors';
import { cx } from '@/ui/utils/cx';

export type AppChipProps = {
  label: React.ReactNode;
  variant?: BadgeVariant;
  size?: 'sm' | 'md';
  selected?: boolean;
  icon?: React.ReactNode;
  onRemove?: () => void;
  onClick?: () => void;
  className?: string;
  title?: string;
};

export default function AppChip({
  label,
  variant = 'neutral',
  size = 'md',
  selected = false,
  icon,
  onRemove,
  onClick,
  className,
  title,
}: AppChipProps) {
  const removable = Boolean(onRemove);
  const interactive = Boolean(onClick) || removable;
  const Tag = onClick ? 'button' : 'span';

  return (
    <Tag
      type={onClick ? 'button' : undefined}
      className={cx(
        'app-chip',
        `app-chip--${variant}`,
        size === 'sm' && 'app-chip--sm',
        selected && 'app-chip--selected',
        interactive && onClick && 'app-chip--interactive',
        className,
      )}
      onClick={onClick}
      title={title}
      aria-pressed={onClick ? selected : undefined}
    >
      {icon ? <span className="app-chip__icon" aria-hidden>{icon}</span> : null}
      <span className="app-chip__label">{label}</span>
      {onRemove ? (
        <button
          type="button"
          className="app-chip__remove"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          aria-label={`Remove ${typeof label === 'string' ? label : 'item'}`}
        >
          ×
        </button>
      ) : null}
    </Tag>
  );
}
